module.exports = __webpack_public_path__ + "img/detention.b8dac013.jpg";